module.exports = __webpack_public_path__ + "static/labsLogo-7e3082ccce8156d0552b829e4723a636.png";